import {
  IAppointment,
  IAppointmentCancellationForm,
  ILocation,
  IOrganizer,
  IActiveVisit
} from 'capability-ng-appointments';
import { PathTask } from 'capability-ng-todos';
import * as _4 from 'lodash4';
import { EnumeratedSetValue } from 'utility-js-enumeration';
import { IDatasource, ORM } from 'utility-ts-orm';

export interface IPreviousState {
  state: string;
  params: object;
}

export interface IPathTask {
  base_ts: moment.Moment;
  calendar_synced: boolean;
  category: EnumeratedSetValue;
  end_ts: moment.Moment;
  event: number;
  id: number;
  is_completable: boolean;
  is_dismissible: boolean;
  is_overdue: boolean;
  is_pending_complete: boolean;
  item: number;
  journey_id: number;
  journey_step: number;
  nk: string;
  overdue_days: number;
  overdue_message: string;
  repeated_by: number;
  show: boolean;
  start_ts: moment.Moment;
  status: string;
  status_changed_ts: moment.Moment;
  substitute_text_by_field_by_item: any;
  _item: {
    presenter: string;
  };
  _journey: any;
  _text: string;
  _title: string;
}

export class MyTodosAppointmentDetailsController {
  models: {
    pathItem: any;
    item: any;
    task: IPathTask;
    appointment: IAppointment;
    topic: string;
  };
  flags: {
    isDateMarkerEvent: boolean;
    hasChildren: boolean;
  };

  appointmentModal: any;
  showCancelForm: boolean;
  isAppointmentCancelled: boolean;
  cancellationForm: IAppointmentCancellationForm;
  appointment: IAppointment;
  activeVisit: IActiveVisit;

  constructor(
    private pathTaskDetail: any,
    private appointmentPathItemFn: any,
    private appointmentDetails: IAppointment,
    private taskUpdateFn: any,
    private EventCategoryEnum: any,
    private $state: ng.ui.IStateService,
    private ngPathTaskDatastore: IDatasource<PathTask>,
    private previousState: IPreviousState,
    private $stateParams: ng.ui.IStateParamsService
  ) {
    this._initialize();
    this.closeModal = this.closeModal.bind(this);
  }
  private _initialize() {
    this.showCancelForm = false;

    this.models = {
      pathItem: this.pathTaskDetail,
      item: this.pathTaskDetail.root,
      task: this.pathTaskDetail.source.task,
      topic: this.$stateParams.topic,
      appointment: this.appointmentPathItemFn.generateAppointmentDetails(this.appointmentDetails)
    };
    this.flags = {
      isDateMarkerEvent: this.EventCategoryEnum.isDateMarker(this.models.task.category),
      hasChildren: !_.isEmpty(this.pathTaskDetail.root.children)
    };

    this.isAppointmentCancelled = this._isAppointmentCancelled;
    this.appointment = this.appointmentDetails;
  }

  isOverdue(task: any) {
    return this.taskUpdateFn.isOverdue(task);
  }

  cancelAppointment() {
    this.showCancelForm = true;
  }

  get _isAppointmentCancelled(): boolean {
    return this.models.appointment.is_cancelled;
  }

  closeModal(): void {
    this.showCancelForm = false;
  }

  reSchedule(): void {
    this.closeModal();
    window.location.assign('#/my/host/as3/appointment-new');
  }

  appointmentCancelledCallback = (cancelForm: any) => {
    this.cancellationForm = cancelForm.cancellationForm;
    this.isAppointmentCancelled = true;
    this.closeModal();
    const id = `${this.models.task.event}_${this.models.task.repeated_by}`;
    this.$state.go('my.todos.appointment', {
      eventId: this.models.task.event,
      repeated_by: this.models.task.repeated_by
    });
    this.ngPathTaskDatastore.del({ ...this.models.task, id } as any);
    ORM.run(this.ngPathTaskDatastore);
  };
}



// WEBPACK FOOTER //
// ./app/lib/my_todos/views/my_todos_appointment_details/my_todos_appointment_details_controller.ts